import { Check, Copy } from "lucide-react";
import type { ActionBarAction } from "./types.ts";

export const copyAction: ActionBarAction = {
  id: "copy",
  icon: Copy,
  tooltip: "Copy",
  activatedIcon: Check,
  autoClear: true,
  show: ({ item }) => !item.isUserMessage && !item.isHeavy && !item.hideCopyAction,
  onClick: ({ item }) => {
    const clipboardItemInput = {
      "text/plain": new Blob([item.content ?? ""], { type: "text/plain" }),
    };
    navigator.clipboard.write([new ClipboardItem(clipboardItemInput)]);
  },
};
